import { useTheme } from "@mui/material/styles"
import React, { useEffect, useState } from "react"
import { Button, Card, CardContent, Divider, Grid, Typography } from "@mui/material"
import styled from "styled-components"
import TestRenderImg from "./test-render.png"
import Gauge from "../Gauge"

const TestWrap = styled.div`
  padding: 2rem;
  margin: 1rem;
  border: 1px solid white;

  > div > div {
    border: 1px solid transparent;
  }

  img {
    height: 300px;
  }
`

export const Test = () => {
  const [validFont, setValidFont] = useState(true)
  const theme = useTheme()

  useEffect(() => {
    if (typeof window !== "undefined") {
      const h2 = document.getElementById("gammaui-test-h2")
      if (typeof h2 !== "undefined") {
        const compStyles = window.getComputedStyle(h2)
        const themeFontFamily = theme.typography.h2.fontFamily.replace(
          /('|"|\s)*/g,
          ""
        )
        const computedFontFamily = compStyles
          .getPropertyValue("font-family")
          .replace(/('|"|\s)*/g, "")
        console.log(themeFontFamily)
        console.log(computedFontFamily)
        if (themeFontFamily !== computedFontFamily) {
          setValidFont(false)
          console.log(themeFontFamily, computedFontFamily)
        }
      }
    }
  }, [theme.typography.h2.fontFamily])
  return (
    <TestWrap>
      <Grid container>
        <Grid item xs={6}>
          <Typography>Image of correct rendering:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>Your render:</Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={6}>
          <img src={TestRenderImg} alt="Test Render" />
        </Grid>
        <Grid item xs={6}>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Gauge label="Gauge" value={87} domain={[0, 100]} suffix="%"/>
                </Grid>
                <Grid item xs={6}>
                <Typography variant="h2" id="gammaui-test-h2" gutterBottom>
                  Test Render
                </Typography>
                <Button variant="contained" color="primary">
                  Button A
                </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      {!validFont ? (
        <Typography variant="h3" style={{ color: "tomato" }}>
          Invalid font detected. Gamma UI has not been loaded correctly.
        </Typography>
      ) : (
        <Typography variant="h3" style={{ color: "green" }}>
          Gamma UI loaded correctly.
        </Typography>
      )}
    </TestWrap>
  )
}

export default Test
